import 'react-responsive-carousel/lib/styles/carousel.min.css';

import * as React from 'react';

import {
  GlanceType,
  Identifier,
  Image,
  ImageType,
  Partner,
  SessionMode,
  SpaceData,
  StudioAppConfig,
} from 'glance-datatypes';

import { Carousel } from 'react-responsive-carousel';
import Utils from '../Utils';
import { Partners } from '../Constants';

interface Props {
  image: Image;
  overlayImage: Image;
  type?: GlanceType;
  customStyle?: React.CSSProperties;
  partner: Partner;
  renderSessionProperties?: any;
  studioAppConfig?: StudioAppConfig;
  spaceData: SpaceData;
  destinationIdentifier: Identifier;
}

const XIAOMI_PARTNER_NAME = 'Xiaomi';
class GlanceWallpaperCard extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const partner = this.props.partner;
    const image = this.props.image;
    const spaceData = this.props.spaceData;
    const destinationIdentifier = this.props.destinationIdentifier;
    const isTranssion = !!partner && partner.partnerId === Partners.TRANSSION_PARTNER_ID;
    const className = partner
      ? !this.props.renderSessionProperties.includes(SessionMode.BINGE)
        ? this.props.type == GlanceType.STORY
          ? partner.name == XIAOMI_PARTNER_NAME
            ? 'glance-overlay xiaomi'
            : 'glance-overlay'
          : partner.name == XIAOMI_PARTNER_NAME
          ? 'glance-overlay xiaomi wallpaper'
          : 'glance-overlay wallpaper'
        : null
      : null;
    const {
      studioAppConfig: { cdnPrefix },
    } = this.props;
    let glanceImage = (
      <div key='glance-image-0'>
        <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
          <div className={className} style={{ float: 'left' }} />
        </div>
        <img
          width='100%'
          style={{ position: 'relative' }}
          src={
            destinationIdentifier === Identifier.SPACE
              ? Utils.getImageUrlForSpaces(cdnPrefix, spaceData)
              : Utils.getImageUrl(cdnPrefix, image, isTranssion? ImageType.STUDIO_ORIGINAL: ImageType.ORIGINAL)
          }
        />
      </div>
    );
    let glanceImageWithOverlay = this.props.overlayImage ? (
      <div>
        <span>
          <img
            width='100%'
            style={{ position: 'relative', top: 0, left: 0 }}
            src={Utils.getImageUrl(
              cdnPrefix,
              this.props.image,
              isTranssion? ImageType.STUDIO_ORIGINAL: ImageType.ORIGINAL,
            )}
          />
          <img
            width='100%'
            style={{ position: 'absolute', top: 0, left: 0 }}
            src={Utils.getImageUrl(
              cdnPrefix,
              this.props.overlayImage,
              ImageType.ORIGINAL,
            )}
          />
        </span>
      </div>
    ) : null;
    let images = [];
    images.push(glanceImage);
    if (glanceImageWithOverlay) {
      images.push(glanceImageWithOverlay);
    }
    return (
      <div
        className=''
        style={{ position: 'relative', ...this.props.customStyle }}
      >
        <Carousel
          showThumbs={false}
          showStatus={false}
          autoPlay={true}
          infiniteLoop={true}
          showIndicators={false}
        >
          {images}
        </Carousel>
      </div>
    );
  }
}

export default GlanceWallpaperCard;



// WEBPACK FOOTER //
// ./src/components/GlanceWallpaperCard.tsx